import React, { useEffect, useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, Typography } from '@mui/material';

import TaskItems from '@dyl/blocks/TaskItems';
import withProps from '@dyl/utils/withProps';
import RubricBlock from '@dyl/blocks/RubricBlock';
import SimpleTaskField from '@dyl/blocks/SimpleTaskField';
import ChipList from '@dyl/components/ChipList';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import useLocalTaskError from '@dyl/pages/Tasks/edit/useLocalTaskError';

export default withProps(TaskItems, { itemComponent: Item });
const CHIPLIST_CHARACTER_LIMIT = 750;
function Item({ index }) {
    const [answers, setAnswers, answersError] = useTaskField('items', index, 'answers', 0, 'key');
    const [shouldCapitalize, setCapitalize, capitalizeError] = useTaskField('items', index, 'is_capital');

    const [q1] = useTaskField('items', index, 'question_1');
    const [shouldShowQ1Error, setShowQ1Error] = useState(false);
    const q1Error = (
        (!q1 && 'Required.')
        || ''
    );

    useLocalTaskError(q1Error, () => setShowQ1Error(true));
    useEffect(() => {
        if (!q1Error) {
            setShowQ1Error(false);
        }
    }, [q1Error]);

    return (
        <>
            <Typography variant='h6'>
                {index === 0 ? 'Example' : `Item ${index}`}
            </Typography>

            {index === 0 && <RubricBlock />}

            <Grid container spacing={2}>
                {/* STIMULUS */}
                <Grid item xs={12}>
                    <SimpleTaskField
                        path={['items', index, 'stimulus_text']}
                        label='Stimulus (Caption)'
                        helperText='Text that will appear in a box overlaying image.'
                    />
                </Grid>

                {/* QUESTION TEXT LEFT */}
                <Grid item xs={12} sm={6}>
                    <SimpleTaskField
                        path={['items', index, 'question_1']}
                        label='Question (and prompt) (left)'
                        helperText={(shouldShowQ1Error && q1Error) || 'Question text that appears before the answer box.'}
                        error={shouldShowQ1Error && !!q1Error}
                        required
                    />
                </Grid>

                {/* QUESTION TEXT RIGHT */}
                <Grid item xs={12} sm={6}>
                    <SimpleTaskField
                        path={['items', index, 'question_2']}
                        label='Prompt (right)'
                        helperText='Question text that appears after the answer box.'
                    />
                </Grid>

                <Grid item xs={12}>
                    <ChipList
                        value={answers}
                        onChange={setAnswers}
                        label='Correct Answers'
                        error={!!answersError}
                        helperText={
                            answersError
                            || `Answers that will be accepted as correct${index === 0 ? ' (max 1 for example)' : ''}.`}
                        required
                        max={index === 0 ? 1 : undefined}
                        maxLen = {CHIPLIST_CHARACTER_LIMIT}
                        isSpellingOrCSPreA1 = {true}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControl error={!!capitalizeError}>
                        <FormControlLabel
                            label='Auto-capitalize'
                            control={<Checkbox
                                color='primary'
                                checked={shouldCapitalize}
                                onClick={() => setCapitalize(prev => !prev)}
                            />}
                        />
                        <FormHelperText>
                            {capitalizeError || (
                                'Should the first letter of the user\'s answer be automatically capitalized?'
                            )}
                        </FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </>
    );
}